import removeSongs from 'state/YourLibrary/removeSongs';
import SongRow from './SongRow';
import { connect } from 'react-redux';
import { flowRight } from 'lodash-es';

export default flowRight(connect(null, { removeSongs: removeSongs.action }))(
  SongRow,
);
